import { GET_BRIDGE_SUBMISSION } from 'src/components/forms/hooks/useBridgeSubmission.gql';
import useTypedSWR from 'src/components/general/useTypedSWR';
import { Staff_BridgeSubmissionReason as BridgeSubmissionReason } from 'src/generated/gql/graphql';

export const useBridgeSubmission = (
  eventId: string | undefined | null,
): BridgeSubmissionReason | null => {
  const { data } = useTypedSWR([
    eventId ? GET_BRIDGE_SUBMISSION : null,
    {
      eventId,
    },
  ]);

  if (!data?.staff_getBridgeSubmissionFromEvent?.reason) {
    return null;
  }

  return data.staff_getBridgeSubmissionFromEvent.reason;
};
